const loadingStatus = {
    loaded: "loaded",
    isLoading: "Loading... Please wait",
    hasErrored: "An error occurred while loading",
};

export default loadingStatus;